import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import i18n from '@/i18n'
import {vuetify} from "@/vuetify";
import {createPinia} from "pinia";
import piniaPersist from 'pinia-plugin-persist'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'


const pinia = createPinia();
pinia.use(piniaPersist);

createApp(App)
    .use(router)
    .use(vuetify)
    .use(i18n)
    .use(pinia)
    .mount('#app')
